import { render, staticRenderFns } from "./ChangeShipDateDialog.vue?vue&type=template&id=6c6588f1&scoped=true"
import script from "./ChangeShipDateDialog.vue?vue&type=script&lang=js"
export * from "./ChangeShipDateDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeShipDateDialog.vue?vue&type=style&index=0&id=6c6588f1&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6588f1",
  null
  
)

export default component.exports